// extracted by mini-css-extract-plugin
export default {"page":"PageWrapper_page__dx-po"};